import { GenericCollectionFactory } from "../_generics";

export const RoomsStore = GenericCollectionFactory("ROOMS", "uid");